export default "__VITE_ASSET__de1c355b__"